import queryString from 'query-string'
import useSWR from 'swr'

import { stringifyParams } from 'utils/stringFormatting'

import * as T from 'types'

import { fetchWithToken } from '../fetchers'
import { getFetchErrorMessage } from './utils/errorMessageHelpers'

export const useHubspotDeal = (id: string = '', queryParams: T.IGetQueryParams = {}) => {
  let apiEndpoint: string | null = null

  if (id) {
    apiEndpoint = `/hubspot-deals/${id}`
    if (Object.keys(queryParams).length) {
      const params = stringifyParams(['filter', 'populate'], queryParams) as T.IGetQueryParams
      apiEndpoint += `?${queryString.stringify(params)}`
    }
  }

  const response = useSWR<T.IHubspotDeal | T.IServerError>(apiEndpoint, fetchWithToken)

  let hubspotDeal: T.IHubspotDeal | undefined

  if (response.data) hubspotDeal = response.data as T.IHubspotDeal

  const error = getFetchErrorMessage(response, 'hubspotDeal')

  return {
    ...response,
    hubspotDeal,
    error,
  }
}
